import { render } from "./LocalesView.vue?vue&type=template&id=47715f37&scoped=true"
import script from "./LocalesView.vue?vue&type=script&lang=js"
export * from "./LocalesView.vue?vue&type=script&lang=js"

import "./LocalesView.vue?vue&type=style&index=0&id=47715f37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47715f37"]])

export default __exports__